/**
 * @fileoverview Audit Log filter vocabularies and limits.
 * @description The closed value lists the Audit Log filters offer, the page size, and the date-range
 * limits that mirror the backend's (AUDIT_QUERY_MAX_RANGE_DAYS defaults to 365 days; page times
 * limit may not pass AUDIT_QUERY_MAX_RESULT_WINDOW, 10,000 by default). The backend has no endpoint
 * that lists event types or modules, so the module list is the modules that publish audit events
 * today; event type is a free, exact-match text filter.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import type { AuditActorType, AuditResult } from '@/features/audit/types/audit.types'

export const AUDIT_RESULTS: readonly AuditResult[] = ['SUCCESS', 'FAILED', 'DENIED']

export const AUDIT_ACTOR_TYPES: readonly AuditActorType[] = ['USER', 'SYSTEM', 'SERVICE']

/** The `sourceModule` values the backend's modules publish, exactly as stored (never case-folded). */
export const AUDIT_SOURCE_MODULES: readonly string[] = [
  'approvals',
  'audit',
  'authorization',
  'identity',
  'notifications',
  'sales-crm',
  'tenants',
  'users',
]

export const AUDIT_PAGE_SIZE = 20

export const AUDIT_DEFAULT_RANGE_DAYS = 7

export const AUDIT_MAX_RANGE_DAYS = 365

export const AUDIT_MAX_RESULT_WINDOW = 10_000

/** An event type: letters, digits and `_ . : -`, at most 100 characters (the backend refuses more). */
export const AUDIT_EVENT_TYPE_PATTERN = /^[A-Za-z0-9_.:-]{1,100}$/
